import { render, staticRenderFns } from "./TicketRewards.vue?vue&type=template&id=4f693cc4&"
import script from "./TicketRewards.vue?vue&type=script&lang=js&"
export * from "./TicketRewards.vue?vue&type=script&lang=js&"
import style0 from "./TicketRewards.vue?vue&type=style&index=0&id=4f693cc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports